export default "__VITE_ASSET__Dli90EoE__"